import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TributosHistoricoComponent } from './tributos-historico/tributos-historico.component';
import { TributosPagarComponent } from './tributos-pagar/tributos-pagar.component';

const routes: Routes = [
  { path: 'historico', component: TributosHistoricoComponent },
  { path: 'pagar', component: TributosPagarComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TributosRoutingModule { }
